import { useInteractiveCallback } from '@/hook/useInteractiveCallback';
import { useAppDispatch, useAppSelector } from '@/store/store';
import { DataState } from '@/types/data.type';
import { Reel } from '@/types/reel.type';

import {
    LIBRARY_REDUCER_NAME,
    clearReelByCode,
    patchReelByCode,
    setFlowsByReelCode,
    setReelByCode,
    setReelState,
} from './library.slice';
import { FlowMapItem } from './library.type';

export function useLibrary() {
    return useAppSelector((state) => state[LIBRARY_REDUCER_NAME]);
}

export function useFlowMap() {
    return useLibrary().flowMap;
}

export function useFlowsByReelCode(reelCode: string) {
    const flowMap = useFlowMap();

    return flowMap?.[reelCode] || [];
}

export function useSetFlowsByReelCode() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((reelCode: string, flows: FlowMapItem[]) => {
        dispatch(setFlowsByReelCode({ reelCode, flows }));
    });
}

export function useReelMap() {
    return useLibrary().reelMap;
}

export function useReelByCode(reelCode: string | null) {
    const reelMap = useReelMap();

    return reelCode ? reelMap?.[reelCode] : undefined;
}

export function useSetReelByCode() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((reelCode: string, reel: Reel) => {
        dispatch(setReelByCode({ reelCode, reel }));
    });
}

export function usePatchReelByCode() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((reelCode: string, patch: Partial<Reel>) => {
        dispatch(patchReelByCode({ reelCode, patch }));
    });
}

export function useReelStateMap() {
    return useLibrary().reelStateMap;
}

export function useReelState(reelCode: string | null) {
    const reelStateMap = useReelStateMap();

    return reelCode ? reelStateMap?.[reelCode] : undefined;
}

export function useSetReelState() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((reelCode: string, state: DataState) => {
        dispatch(setReelState({ reelCode, state }));
    });
}

export function useClearReelByCode() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((reelCode: string) => {
        dispatch(clearReelByCode({ reelCode }));
    });
}
